// Variation to use for Split Testing Flags when the flag is disabled
export const DEFAULT_SPLIT_VARIATION = 'control';

export const VariationTypes = {
  A_B_TESTING: ['control', 'variant', 'not-included'],
  CUSTOM: [], // defined by `featureFlag.variations`
  ROLLOUT: ['on', 'off'],
} as const;
